import { CiSearch, CiCircleInfo, CiPower } from "react-icons/ci";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { PiCopySimpleThin } from "react-icons/pi";
import { IoIosClose, IoMdCheckmark } from "react-icons/io";
import { FaChevronLeft, FaAngleRight } from "react-icons/fa6";
import { FiCalendar } from "react-icons/fi";

export let reactIcons = {
  checkMarkIcon: IoMdCheckmark as React.FC<React.SVGProps<SVGSVGElement>>,
  leftIcon: FaChevronLeft as React.FC<React.SVGProps<SVGSVGElement>>,
  rightIcon: FaAngleRight as React.FC<React.SVGProps<SVGSVGElement>>,
  closeIcon: IoIosClose as React.FC<React.SVGProps<SVGSVGElement>>,
  ciPowerIcon: CiPower as React.FC<React.SVGProps<SVGSVGElement>>,
  copyIcon: PiCopySimpleThin as React.FC<React.SVGProps<SVGSVGElement>>,
  infoIcon: CiCircleInfo as React.FC<React.SVGProps<SVGSVGElement>>,
  searchIcon: CiSearch as React.FC<React.SVGProps<SVGSVGElement>>,
  visibilityOffIcon: IoEyeOffOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  visibilityOnIcon: IoEyeOutline as React.FC<React.SVGProps<SVGSVGElement>>,
  calendarIcon: FiCalendar as React.FC<React.SVGProps<SVGSVGElement>>,
};
